module.exports = ".edit-admin {\n  width: 100%;\n  max-width: 800px;\n  margin: 86px auto;\n  padding: 0 50px;\n}\n@media (min-width: 700px) {\n  .edit-admin {\n    padding: 0 180px 0 0;\n  }\n}\n.edit-admin .sg-btn {\n  margin: 25px 2px 2px;\n}\n.edit-admin .edit-clickable {\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.less
// module id = ./src/app/admin/admin.less
// module chunks = main